var _linearGradient, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.673,
    x2: 112.328,
    y1: 110.913,
    y2: 14.258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcca29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25b0f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.9 65h-17.1l17.1 17.1zm.6 23.3-20.6-20.5v47.4l3.4-3.4c.8-.8 2-.8 2.8 0l5.4 5.4 5.4-5.4c.8-.8 2-.8 2.8 0l5.4 5.4 5.4-5.4c.8-.8 2-.8 2.8 0l5.4 5.4 5.4-5.4c.8-.8 2-.8 2.8 0l5.4 5.4 5.4-5.4c.8-.8 2-.8 2.8 0l3.4 3.4v-26.3h-42c-.6 0-1.1-.2-1.4-.6zm3.4-78.3v74.9h64.2v-74.9zm9.3 26.8h6.9v4h-6.9zm0 11.4h6.9v4h-6.9zm13.9 15.5h-9.9v1.4h6.1c2.1 0 3.8 1.7 3.8 3.8v1.9c0 2.1-1.7 3.8-3.8 3.8h-1.2v2.8h-4v-2.8h-4.9v-4h9.9v-1.4h-6.1c-2.1 0-3.8-1.7-3.8-3.8v-1.9c0-2.1 1.7-3.8 3.8-3.8h1.2v-2.8h4v2.8h4.9zm32.3 11.3h-27.4v-4h27.4zm0-11.4h-27.4v-4h27.4zm0-11.4h-31.4v-4h31.4zm0-11.4h-31.4v-4h31.4zm0-13.3c0 1.1-.9 2-2 2h-42.2c-1.1 0-2-.9-2-2v-8.7c0-1.1.9-2 2-2h42.2c1.1 0 2 .9 2 2zm-42.2-2h38.2v-4.7h-38.2z",
    fill: "url(#SVGID_1_)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.3ba4292f7e3f5ffd8392b4fe6f5d46d1.svg";
export { ForwardRef as ReactComponent };